export default __webpack_public_path__ + "9f513fd9d72812b21d17ba840a139c5e.png";